import isTrue from '@/utils/isTrue';
import pickBy from 'lodash/pickBy';

export default function pickTure(obj) {
  return pickBy(obj, isTrue);
}
